import { update } from './update';

export function request({ mobilePhone }) {
    return {
        type: 'USER_CHANGE_CONTACT_NUMBER_REQUEST',
        mobilePhone
    };
}

export function error(errors) {
    return {
        type: 'USER_CHANGE_CONTACT_NUMBER_ERROR',
        errors
    };
}

export function finish(user) {
    return (dispatch) => {
        dispatch(update(user));

        dispatch({
            type: 'USER_CHANGE_CONTACT_NUMBER_FINISH'
        });
    };
}

export function clear() {
    return {
        type: 'USER_CHANGE_CONTACT_NUMBER'
    };
}
